"use client";

import React, { useState } from "react";
import { MapPin } from "lucide-react";
const CITIES = [{
  id: "hudson",
  name: "Hudson, WI",
  x: 25,
  y: 25
}, {
  id: "river-falls",
  name: "River Falls, WI",
  x: 45,
  y: 45
}, {
  id: "prescott",
  name: "Prescott, WI",
  x: 20,
  y: 75
}, {
  id: "ellsworth",
  name: "Ellsworth, WI",
  x: 65,
  y: 65
}];
export default function LocalServiceAreas() {
  const [activeCity, setActiveCity] = useState<string | null>(null);
  return <section id="local-service-areas" className="py-24 bg-background relative overflow-hidden">
      {}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMiIgY3k9IjIiIHI9IjEiIGZpbGw9IiMwMDAiLz48L3N2Zz4=')] [mask-image:linear-gradient(to_bottom,white,transparent)]" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          
          {}
          <div className="space-y-12">
            <div className="space-y-6">
              <h2 className="text-sm font-bold tracking-widest text-primary uppercase">
                Our Service Area
              </h2>
              <p className="text-lg text-muted-foreground leading-relaxed max-w-md">
                As a family-owned, community-first business, we take pride in transforming homes across Western Wisconsin. For over 20 years, we've built our reputation on trust, quality craftsmanship, and long-term relationships with our neighbors.
              </p>
            </div>

            <ul className="space-y-6">
              {CITIES.map((city, i) => <li key={city.id} data-index={i} className="group flex items-center gap-4" onMouseEnter={() => setActiveCity(city.id)} onMouseLeave={() => setActiveCity(null)}>
                  <div className={`transition-all duration-300 ease-in-out flex items-center justify-center size-10 rounded-full border ${activeCity === city.id ? "bg-primary border-primary text-primary-foreground shadow-md scale-110" : "bg-transparent border-border text-muted-foreground group-hover:border-primary/50 group-hover:text-primary"}`}>
                    <MapPin className="size-5" />
                  </div>
                  <span className={`font-sans text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight transition-colors duration-300 cursor-default ${activeCity === city.id ? "text-foreground" : "text-muted-foreground/50 group-hover:text-foreground/80"}`}>
                    {city.name.split(',')[0]}
                  </span>
                </li>)}
            </ul>
          </div>

          {}
          <div className="relative w-full aspect-square max-w-lg mx-auto lg:ml-auto bg-muted/20 rounded-3xl border border-border/50 shadow-sm overflow-hidden flex items-center justify-center p-8">
            <svg viewBox="0 0 100 100" className="w-full h-full drop-shadow-sm" preserveAspectRatio="xMidYMid meet">
              {}
              <path d="M 15 -10 Q 30 20 15 50 T 25 80 Q 20 100 10 110" fill="none" stroke="var(--color-primary)" strokeWidth="0.5" strokeOpacity="0.2" className="animate-pulse" style={{
              animationDuration: '4s'
            }} />
              <path d="M 18 -10 Q 33 20 18 50 T 28 80 Q 23 100 13 110" fill="none" stroke="var(--color-primary)" strokeWidth="0.2" strokeOpacity="0.1" />

              {}
              {CITIES.map((city, i) => {
              const isActive = activeCity === city.id;
              return <g key={`marker-${city.id}`} data-index={i} className="transition-all duration-500 ease-out" style={{
                transform: `translate(${city.x}px, ${city.y}px)`
              }}>
                    {}
                    <circle cx="0" cy="0" r={isActive ? "8" : "0"} fill="var(--color-primary)" opacity="0.2" className="transition-all duration-500" />
                    
                    {}
                    <circle cx="0" cy="0" r={isActive ? "3" : "1.5"} fill={isActive ? "var(--color-primary)" : "var(--color-muted-foreground)"} className="transition-all duration-300" />

                    {}
                    <text x="6" y="1" fontSize="3.5" fontWeight={isActive ? "bold" : "normal"} fill={isActive ? "var(--color-foreground)" : "var(--color-muted-foreground)"} className="font-sans transition-all duration-300 select-none" opacity={isActive ? 1 : 0.6}>
                      {city.name}
                    </text>
                  </g>;
            })}
            </svg>
          </div>

        </div>
      </div>
    </section>;
}